
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface SubjectBadgeProps {
  subject: string;
  courseTypes: string[];
}

export const SubjectBadge: React.FC<SubjectBadgeProps> = ({
  subject,
  courseTypes,
}) => {
  return (
    <div className="flex flex-wrap gap-1 items-center">
      <Badge variant="outline" className="text-xs flex items-center gap-1">
        {subject}
        {courseTypes.map((courseType, typeIndex) => (
          <span
            key={typeIndex}
            className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-[10px] font-bold ${
              courseType === 'Inter'
                ? 'bg-blue-500 text-white'
                : 'bg-green-500 text-white'
            }`}
          >
            {courseType === 'Inter' ? 'I' : 'R'}
          </span>
        ))}
      </Badge>
    </div>
  );
};
